export default __webpack_public_path__ + "static/media/2.223d8ad0.png";